import {Trend, TrendProps} from 'platform/components';
import {match, Pattern} from 'ts-pattern';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

interface CompareTrendProps {
  value: number | Nullish;
  formatter?: (value: number) => string | null;
  reverse?: boolean;
  isBig?: boolean;
}

export function CompareTrend(props: CompareTrendProps) {
  const trendParams: TrendProps = match(props.value)
    .with(Pattern.number.gt(0), (value) => ({
      label: `+${props.formatter?.(value) ?? value}`,
      isPositive: !props.reverse,
      isNegative: props.reverse,
    }))
    .with(Pattern.number.lt(0), (value) => ({
      label: props.formatter?.(value) ?? `${value}`,
      isPositive: props.reverse,
      isNegative: !props.reverse,
    }))
    .otherwise(() => ({
      label: EMPTY_PLACEHOLDER,
    }));

  return (
    <Trend
      label={trendParams.label}
      isPositive={trendParams.isPositive}
      isNegative={trendParams.isNegative}
      isTransparent={trendParams.isTransparent}
      isSubtle
      isSmall={!props.isBig}
    />
  );
}
